import React, { Fragment } from 'react';
import t from '@jetshop/intl';
import PageContent from '../../Util/PageContent';
import { Above } from '@jetshop/ui/Breakpoints';
import parse from 'html-react-parser';
import { ProductDescription } from './ProductDescription';
import { DesktopTabs } from './DesktopTabs';
import { MobileDrops } from './MobileDrops';
import { TabData } from './TabData';
import { styled } from 'linaria/react';
import GetStartPage from '../../StartPage/GetStartPage';
import { theme } from '../../Theming/Theming';
import TextContent from '../../ui/TextContent';
import CustomProductSpecifications from './CustomProductSpecifications';
import SpareParts from '../SpareParts/SpareParts';
import { Files } from './Files';
import { Technologies } from '../Technologies/Technologies.js.js';
import { PriceHistoryWrapper } from '../Price/PriceHistory';

const ProductTabsWrapper = styled('div')`
  ${theme.above.lg} {
    .content-area,
    .specifications-wrapper {
      max-width: 700px;
      margin: 2rem auto;
    }
    .content-area.price {
      max-width: 400px;
    }
  }
`;

const HeaderAmount = styled('span')`
  margin-left: 5px;
  &:after {
    content: ')';
  }
  &:before {
    content: '(';
  }
`;

const multipleDescriptionTabs = false;

const ProductTabs = ({
  loading,
  product,
  customFields,
  customTabs,
  customData,
  selectedVariation
}) => {
  const tabsData = [];

  //PARSE DESCRIPTION
  let descriptionData = parse(product.description ? product.description : '');

  //FORCE descriptionData TO BE ARRAY
  if (!Array.isArray(descriptionData)) {
    descriptionData = [{ ...descriptionData, key: 1 }];
  }

  //WRAP TABLES
  const elementList = [];
  descriptionData.forEach(function(element, index) {
    if (element.type === 'table') {
      elementList.push(
        <div className="table-wrap" key={'table-wrap-' + index}>
          {element}
        </div>
      );
    } else elementList.push(element);
  });
  descriptionData = elementList;

  //SPLIT DESCRIPTION INTO MULTIPLE TABS OR KEEP INTACT
  if (multipleDescriptionTabs && descriptionData.length > 0) {
    let descriptionTabs = [];
    let tab = {
      header: t('Product description'),
      list: []
    };
    descriptionData.forEach(function(element, index) {
      if (element.type !== 'h2') {
        tab.list.push(element);
      }
      if (element.type === 'h2' || index + 1 === descriptionData.length) {
        descriptionTabs.push(tab);
      }
      if (element.type === 'h2') {
        tab = {
          header: element.props.children,
          list: []
        };
      }
    });

    descriptionTabs.forEach(function(tab, index) {
      tabsData.push({
        header: tab.header,
        id: 'descr-' + index,
        body: <ProductDescription list={tab.list} />
      });
    });
  } else {
  }

  //DESCRIPTION
  tabsData.push({
    header: t('Product description'),
    id: 'descr',
    body: <ProductDescription product={product} />
  });

  //SPECIFICATIONS
  if (customFields && customFields.length) {
    tabsData.push({
      header: (
        <span>
          {t('Specifications')}
          <HeaderAmount className="amount">{customFields.length}</HeaderAmount>
        </span>
      ),
      body: (
        <CustomProductSpecifications fields={customFields} productPage={true} />
      )
    });
  }

  //PRICE HISTORY
  if (!product.hidePrice) {
    tabsData.push({
      header: t('Price History'),
      id: 'price-history',
      body: (
        <div className="content-area price">
          <PriceHistoryWrapper
            articleNumber={product.articleNumber}
            variant={selectedVariation}
          />
        </div>
      )
    });
  }

  //CUSTOM TABS
  if (customTabs && customTabs.length) {
    customTabs.forEach(function(tab, index) {
      //GET PAGE
      if (tab.getPage) {
        tabsData.push({
          header: tab.title,
          id: 'page-' + tab.pageId,
          body: (
            <PageContent pageId={tab.pageId}>
              {page => (
                <TextContent
                  className="custom-tab-page"
                  content={page && page.content}
                />
              )}
            </PageContent>
          )
        });

        //GET STARTPAGE
      } else if (tab.getStartPage) {
        tabsData.push({
          header: tab.title,
          id: 'startpage-' + tab.pageId,
          body: <GetStartPage startPageId={tab.pageId} />
        });
      }

      //SHOW FIELD DATA
      else {
        tabsData.push({
          header:
            tab.listValues && tab.listValues.length ? (
              <span>
                {tab.title}
                <HeaderAmount className="amount">
                  {tab.listValues.length}
                </HeaderAmount>
              </span>
            ) : (
              tab.title
            ),
          id: 'custom' + tab.key,
          body: <TabData data={tab} />
        });
      }
    });
  }

  //SPARE PARTS
  const spareparts = customData.filter(
    item => item.key.search('spareparts') !== -1
  )[0];
  const list = spareparts && spareparts.listValues;

  if (list && list.length > 0) {
    //SPARE PARTS
    tabsData.push({
      header: spareparts.title,
      id: 'spareparts',
      body: <SpareParts list={list} />
    });
  }

  //FILES
  const files = customData.filter(item => item.key.search('docs') !== -1)[0];
  const filesList = files && files.listValues;

  if (filesList && filesList.length > 0) {
    //SPARE PARTS
    tabsData.push({
      header: files.title,
      id: 'docs',
      body: <Files list={filesList} />
    });
  }

  //TECH
  const tech = customData.filter(
    item => item.key.search('technologies') !== -1
  )[0];
  const techList = tech && tech.listValues;

  if (techList && techList.length > 0) {
    //SPARE PARTS
    tabsData.push({
      header: tech.title,
      id: 'tech',
      body: <Technologies data={tech} />
    });
  }

  return (
    <Fragment>
      <Above breakpoint="lg">
        {match => (
          <ProductTabsWrapper>
            {match ? (
              <DesktopTabs tabsData={tabsData} />
            ) : (
              <MobileDrops tabsData={tabsData} />
            )}
          </ProductTabsWrapper>
        )}
      </Above>
    </Fragment>
  );
};

export default ProductTabs;
